/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const JobFrequency = {
    None: 'None',
    Daily: 'Daily',
    Weekly: 'Weekly',
    Monthly: 'Monthly',
    Yearly: 'Yearly'
} as const;
export type JobFrequency = typeof JobFrequency[keyof typeof JobFrequency];


export function JobFrequencyFromJSON(json: any): JobFrequency {
    return JobFrequencyFromJSONTyped(json, false);
}

export function JobFrequencyFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobFrequency {
    return json as JobFrequency;
}

export function JobFrequencyToJSON(value?: JobFrequency | null): any {
    return value as any;
}

/**
 * Check if a given object implements the JobFrequency interface.
 */
 export function instanceOfJobFrequency(value: any): value is JobFrequency {
    return Object.values(JobFrequency).includes(value)
}

